import React from 'react';
import Contact from '../Contact';
export default function ArabicContact() { return <Contact language="ar"/>; }
